import styles from './RecommendationPage.module.scss';
import { PlanSearchCriteria } from './types';
import UILink from 'components/ui/UILink';
import PencilIcon from 'components/icons/PencilIcon';

const PLAN_TYPE_LABELS: Record<PlanSearchCriteria['type'], string> = {
  ma: 'Medicare Advantage',
  mapd: 'Medicare Advantage',
  gap: 'Medicare Supplement',
  pdp: 'Prescription Drug',
};

type ResultsSummaryProps = {
  zipcode: string;
  plansDisplayed: number;
  planType: PlanSearchCriteria['type'];
  isLoading?: boolean;
};

const ResultsSummary = ({
  zipcode,
  plansDisplayed,
  planType,
  isLoading,
}: ResultsSummaryProps) => {
  return (
    <div className={styles.resultsSummary}>
      <p>
        {!isLoading && (
          <>
            We found {plansDisplayed} <b>{PLAN_TYPE_LABELS[planType]}</b> plans
            in{' '}
            <UILink
              textType="body"
              size="medium"
              label={zipcode}
              href="/browse"
              icon={<PencilIcon />}
            />
          </>
        )}
      </p>
    </div>
  );
};

export default ResultsSummary;
